import { isFeatureRunning } from "../utils/features";

export const useIsAggregatedAirline = (): boolean =>
  isFeatureRunning("FLIGHTS_PARTNER_STRATEGY_MANAGER_AGGREGATED_AIRLINE_PERFORMANCE");
